import { ObjectDeps } from '@fullstory/proto/fs/services/dx-objects';

export const newTestDeps = (data: Partial<ObjectDeps> = {}): ObjectDeps => ({
  cards: {},
  dashboards: {},
  dataTables: {},
  definedEvents: {},
  funnels: {},
  heatmaps: {},
  journeys: {},
  metrics: {},
  namedElements: {},
  pages: {},
  properties: {},
  relatedSpaces: {},
  retentionMetrics: {},
  segments: {},
  spaces: {},
  specs: {},
  specMappings: {},
  unnamedDataTables: {},
  unnamedFunnels: {},
  unnamedHeatmaps: {},
  unnamedJourneys: {},
  unnamedMetrics: {},
  unnamedOverlays: {},
  unnamedRetention: {},
  unnamedSegments: {},
  ...data,
});
